<template>
  <div class="modal fade modal__default" :id="modalId" role="dialog">
    <div class="modal-dialog modal__default__dialog" :style="{'width': width, 'margin-top': marginTop}">
      <div class="modal-content modal__default__content">
        <div class="row modal__default__container">
          <div class="modal__default__header">
            <a type="button" class="modal__default__close" data-dismiss="modal">
              <ion-icon name="close"></ion-icon>
            </a>
            <div class="modal__default__title">
              <span>{{ modalTitle }}</span>
            </div>
            <div v-if="modalSubtitle" class="modal__default__subtitle">
              <span>{{ modalSubtitle }}</span>
            </div>
          </div>
          <div class="modal__default__body">
            <slot/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "modalDefault",
  props: {
    modalId: {
      required: true
    },
    modalTitle: {
      required: true
    },
    modalSubtitle: {
      default: '',
    },
    width: {
      default: '',
    },
    marginTop: {
      default: '',
    }
  },
  methods: {
    closeModal() {
      $(`#${this.modalId}`).modal('hide');
      this.$emit('modal-closed');
    }
  },
  mounted() {
    $(`#${this.modalId}`).on('hidden.bs.modal', () => {
      this.closeModal()
    });
  }
}
</script>

<style lang="scss" scoped>

.modal__default {
  &__dialog {
    margin-top: 70px;
  }

  &__dialog > &__content {
    border: none;
    box-shadow: none;
    border-radius: 8px !important;
    padding: 20px 30px;
  }

  &__dialog > &__content > &__container {
    margin: 0;
  }

  &__dialog > &__content > &__container > &__header {
    position: relative;
    padding: 0 0 10px 0;
    border-bottom: 1px solid #E6E9EC;
  }

  &__dialog > &__content > &__container > &__header > &__title {
    span {
      display: flex;
      align-items: flex-start;
      font-size: 21px;
      font-weight: 700;
      color: #191919;
    }
  }

  &__dialog > &__content > &__container > &__header > &__subtitle {
    span {
      font-size: 14px;
      font-weight: 400;
      color: var(--dark-gray);
    }
  }

  &__dialog > &__content > &__container > &__header > &__close {
    position: absolute;
    right: 0;
    top: 0;
    height: 30px;
    color: #BACADC;
    transition: .2s;

    &:hover {
      color: #7F8897;
    }

    ion-icon {
      font-size: 30px;
      pointer-events: none;
    }
  }

  &__dialog > &__content > &__container > &__body {
    margin-top: 10px
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/modals/modalDefault.vue